'use client';

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'motion/react';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'true');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:max-w-md z-50"
        >
          <div className="bg-slate-900 border border-slate-800 rounded-[2rem] p-6 shadow-2xl shadow-black/50 backdrop-blur-xl">
            <div className="flex items-start gap-4">
              <div className="bg-blue-600 p-3 rounded-2xl text-white shrink-0">
                <Cookie className="w-6 h-6" />
              </div>
              <div className="space-y-4">
                <div>
                  <h3 className="text-white font-black uppercase tracking-tighter italic text-lg">Cookies e Privacidade</h3>
                  <p className="text-slate-400 text-sm font-medium leading-relaxed mt-1">
                    Utilizamos cookies para melhorar sua experiência no portal. Ao continuar navegando, você concorda com nossa{' '}
                    <Link to="/privacidade" className="text-blue-400 underline underline-offset-4 hover:text-blue-300 transition-colors">
                      Política de Privacidade
                    </Link>.
                  </p>
                </div>
                <div className="flex gap-3">
                  <button
                    onClick={acceptCookies}
                    className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-black uppercase tracking-tighter italic flex items-center justify-center gap-2 transition-all active:scale-95"
                  >
                    <Check className="w-4 h-4" />
                    Aceitar Tudo
                  </button>
                  <button
                    onClick={() => setIsVisible(false)}
                    className="p-3 text-slate-400 hover:text-white transition-colors"
                    title="Fechar"
                  >
                    <X className="w-6 h-6" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
